import React, { useState } from "react";
import MainLayout from "./mainLayout";
import logo from '../leclab-madrid-vertical.png'
import EventsCalendar from "./eventsCalendar";
import UserPromos from "./userPromos";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function UserPage() {
    const [content, setContent] = useState('calendar')
    const { userInfo, logout } = useAuth()
    const navigate = useNavigate()

    const doLogout = (e) => {
        e.preventDefault()
        logout().finally(() => navigate('/'))
        // navigate('/')
    }

    return (
        <MainLayout>
            <header className="p-3 bg-light sticky-top">
                <div className="container">
                    <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                        <a href="/" className="d-flex align-items-center mb-2 mx-2 mb-lg-0 text-white text-decoration-none">
                            <img src={logo} width={50} className="rounded bg-white p-1" />
                        </a>
                        
                        <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                            <li><a className="nav-link px-2 text-dark" style={{ cursor: 'pointer' }} onClick={() => setContent('calendar')}>Calendario</a></li>
                            <li><a className="nav-link px-2  text-dark" style={{ cursor: 'pointer' }} onClick={() => setContent('promos')}>Promociones</a></li>
                        </ul>

                        <div className="text-end">
                            {userInfo?.isAdmin && <button type="button" className="btn btn-outline-dark me-2" onClick={() => navigate('/admin')}>Ir a modo administrador</button>}
                            <button type="button" className="btn btn-dark" onClick={doLogout}>Logout</button>
                        </div>
                    </div>
                </div>
            </header>

            {content === 'calendar' && <EventsCalendar />}
            {content === 'promos' && <UserPromos />}
        </MainLayout>
    );
};

export default UserPage;